import { AxDropdown, Direction } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("CustomerLessonProperties")
export class CustomerLessonProperties implements AxInit {
    private allergiesOtherID = '56'; // Other. DB driven ID
    private medicalIssueOtherID = '10'; // Other. DB driven ID

    private lessonAllergiesDropDown: AxDropdown;
    private lessonLanguagesDropDown: AxDropdown;
    private lessonMedicalsDropDown: AxDropdown;
    private lessonLevelsDropDown: AxDropdown;

    private $hiddenAllergies: JQuery<HTMLElement>;
    private $hiddenMedicalStates: JQuery<HTMLElement>;
    private $hiddenLanguages: JQuery<HTMLElement>;

    private formElementPrefix: string;

    private allDropdowns: AxDropdown[] = [];

    public allergies: LessonProperty[] = [];
    public medicalStates: LessonProperty[] = [];
    public languages: LessonProperty[] = [];
    public lessonLevels: LessonProperty[] = [];

    AxInit(init: CustomerLessonPropertiesInit): void {
        this.formElementPrefix = init.formElementPrefix;

        this.$hiddenAllergies = $(`${init.parentId} .hidden_allergies`);
        this.$hiddenMedicalStates = $(`${init.parentId} .hidden_medicalStates`);
        this.$hiddenLanguages = $(`${init.parentId} .hidden_languages`);
        //this.hiddenLessonLevels = document.querySelector(`${init.parentId} .hidden_lessonLevels`) as HTMLElement;

        this.initLessonPropertyDropdowns(init.parentId);

        // So this can be triggered by any JS like lessonsBuyerInfo.js
        $('body').on('AddToCartLessons', (e, form) => {
            this.setDescriptionAndGenerateHiddenFieldForLessonProperties(form);
        });
    }

    private initLessonPropertyDropdowns(parentId: string) {
        this.initAllergiesDropdown(parentId);
        this.initLanguagesDropdown(parentId);
        this.initMedicalsDropdown(parentId);
        this.initLevelsDropdown(parentId);
    }

    private initAllergiesDropdown(parentId: string) {
        this.lessonAllergiesDropDown = new AxDropdown();
        this.lessonAllergiesDropDown.init(`${parentId} .lesson-property-dropDown_allergies`, {
            searchBar: true,
            multiSelect: true,
            onOpen: () => { },                
            onChange: this.getSelectedEntities('allergies', LessonPropertyType.LessonAllergies, this.$hiddenAllergies),
        });

        this.allDropdowns.push(this.lessonAllergiesDropDown);
    }

    private initLanguagesDropdown(parentId: string) {
        this.lessonLanguagesDropDown = new AxDropdown();
        this.lessonLanguagesDropDown.init(`${parentId} .lesson-property-dropDown_languages`, {
            searchBar: false,
            multiSelect: true,
            onOpen: () => { },
            onChange: this.getSelectedEntities('languages', LessonPropertyType.LessonLanguages, this.$hiddenLanguages),
        });

        this.allDropdowns.push(this.lessonLanguagesDropDown);
    }

    private initMedicalsDropdown(parentId: string) {
        this.lessonMedicalsDropDown = new AxDropdown();
        this.lessonMedicalsDropDown.init(`${parentId} .lesson-property-dropDown_medicalStates`, {
            searchBar: true,
            multiSelect: true,
            onOpen: () => { },
            onChange: this.getSelectedEntities('medicalStates', LessonPropertyType.LessonMedicals, this.$hiddenMedicalStates),
        });

        this.allDropdowns.push(this.lessonMedicalsDropDown);
    }

    private initLevelsDropdown(parentId: string) {
        this.lessonLevelsDropDown = new AxDropdown();
        this.lessonLevelsDropDown.init(`${parentId} .lesson-property-dropDown_lessonLevels`, {
            searchBar: false,
            multiSelect: true,
            onOpen: () => { },
            onSelect: (elem, values) => {
                //if (Array.isArray(values)) {
                //    this.hiddenLessonLevels.value = values.join(',');
                //} else {
                //    this.hiddenLessonLevels.value = values;
                //}
            }
        });

        this.allDropdowns.push(this.lessonLevelsDropDown);
    }

    private getSelectedItems(e: JQuery<HTMLElement>, type: LessonPropertyType): any {
        const findResult = $(e?.get(0)).find('a span div');
        const result = findResult.map((_, e) => ({ fieldText: $(e).text(), fieldValue: $(e).attr('data-value') })).toArray();

        this.checkOtherTextboxVisibility(type, result?.some((x) => (
            (type == LessonPropertyType.LessonAllergies && x.fieldValue === this.allergiesOtherID)
            || (type == LessonPropertyType.LessonMedicals && x.fieldValue === this.medicalIssueOtherID)
        )));
        return result;
    }

    private getSelectedEntities = (entity: string, type: LessonPropertyType, $container: JQuery<HTMLElement>) => (
        $parent: JQuery<HTMLElement>,
        changedValue: string,
        direction: Direction,
        values: string | string[]
    ): void => {                    
        const selectedItems = this.getSelectedItems($parent, type);
        const selectedLanguages = Array.isArray(values) ? values : [values];
        this[entity] = selectedLanguages?.map((value, i) => {
            const item = selectedItems?.find((s) => s.fieldValue == value);
            const description = this[entity]?.find((e: LessonProperty) => e.id == value)?.description;
            return new LessonProperty(value, item?.fieldText, type, description);
        });
        this.createFormElementProp(LessonPropertyType[type], this[entity], $container);
    }

    private createFormElementProp(propFieldName: string, lessonProperties: LessonProperty[], $parent: JQuery<HTMLElement>) {
        $parent.html('');
        lessonProperties.map((lesson, i) => {
            const properties = Object.keys(lesson);
            properties.forEach((property) => {
                const $propElement: JQuery<HTMLElement> = $('<input>', {
                    type: 'hidden',
                    name: `${this.formElementPrefix}${propFieldName}[${i}].${property}`,
                    value: lesson[property],
                });
                $parent.append($propElement);
            });
        });
    }

    //Check if Other is selected, then show the textbox for the LessonPropertyType
    private checkOtherTextboxVisibility(type: LessonPropertyType, visible: boolean) {
        let identifier = '';

        switch (type) {
            case LessonPropertyType.LessonAllergies:
                identifier = 'other_allergies';
                break;
            case LessonPropertyType.LessonMedicals:
                identifier = "other_medicalStates";
                break;
            default:
                break;
        };
        
        $(`[data-lesson-property-other-id="${identifier}"]`)?.toggleClass('d-none', !visible); 
    }

    //Loop over allergies, and medicalStates to set description value and add hidden fields to serialize properly for all arrays.
    setDescriptionAndGenerateHiddenFieldForLessonProperties(formName: string) {
        //Allergies
        let descriptionValue = $(`#${formName} #other_allergies`)?.val() as string;
        this.allergies.forEach((item, i) => {
            if (item.id === this.allergiesOtherID) {
                item.description = descriptionValue;
            }
        });        
        this.createFormElementProp(LessonPropertyType[LessonPropertyType.LessonAllergies], this.allergies, this.$hiddenAllergies);

        //MedicalStates
        descriptionValue = $(`#${formName} #other_medicalStates`)?.val() as string;
        this.medicalStates.forEach((item, i) => {
            if (item.id === this.medicalIssueOtherID) {
                item.description = descriptionValue;
            }
        });
        this.createFormElementProp(LessonPropertyType[LessonPropertyType.LessonMedicals], this.medicalStates, this.$hiddenMedicalStates);

        //Languages
        this.createFormElementProp(LessonPropertyType[LessonPropertyType.LessonLanguages], this.languages, this.$hiddenLanguages);
    }
}

export class LessonProperty {
    public id: string;
    public name: string;
    public lessonPropertyType: LessonPropertyType;
    public description: string;

    constructor(
        id: string,
        name: string,
        lessonPropertyType: LessonPropertyType,
        description: string = ''
    ) {
        this.id = id;
        this.name = name;
        this.lessonPropertyType = lessonPropertyType;
        this.description = description;
    }    
}

export enum LessonPropertyType {
    LessonAllergies = 1,
    LessonMedicals = 2,
    LessonLanguages = 3
}

export interface CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;
}

export class InitCustomerProps implements CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;

    constructor(parentId: string, formElementPrefix: string) {
        this.parentId = parentId;
        this.formElementPrefix = formElementPrefix;
    }
}

